import { effects } from 'redux-saga'

import { rememberSignup } from '../../modules/signupEdit/actions'

export default function* remember(action) {
  // eslint-disable-next-line no-restricted-syntax
  for (const signup of action.payload.signups) {
    yield effects.put.resolve(
      rememberSignup(signup.reference, signup.accessKey),
    )
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/remember.js